import { render, staticRenderFns } from "./nutritionSearch.vue?vue&type=template&id=28349f4c"
import script from "./nutritionSearch.vue?vue&type=script&lang=js"
export * from "./nutritionSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports